export const getSelectedLanguageKey = (
  respondentId: string,
  surveyId: string
) => `${respondentId}.${surveyId}.selectedLanguage`

const get = (respondentId: string, surveyId: string): string | undefined =>
  window.localStorage.getItem(getSelectedLanguageKey(respondentId, surveyId)) ??
  undefined

const set = (respondentId: string, surveyId: string, language: string) => {
  window.localStorage.setItem(
    getSelectedLanguageKey(respondentId, surveyId),
    language
  )
}

const clear = (respondentId: string, surveyId: string) => {
  window.localStorage.removeItem(getSelectedLanguageKey(respondentId, surveyId))
}

export const persistedSelectedLanguage = { get, set, clear }
